import React, { useRef } from 'react';
import { prop } from 'ramda';
import { useMountEffect } from 'js/hooks/useMountEffect';
import { languageService } from 'js/services/language.service';
import { useUserSelector } from 'js/store/hooks';
import { getScript } from 'js/utils/scripts.util';
import { getCaptchaPublicKeyDirect } from 'js/hooks/auth/pas';

import { ERRORS } from './constants';
import { useRenderRecaptcha } from './hooks';

import style from './index.scss';

// this needs to be ReCaptcha once backbone will be removed
export const ReCaptchaBare = ({
    lang,
    onValidate,
    onError,
    operation,
    theme = 'light',
    size = 'normal',
    tabIndex = 0
}) => {
    const language = languageService.getLanguage(lang);
    const captchaRef = useRef();
    const renderRecaptcha = useRenderRecaptcha({
        language,
        onValidate,
        onError,
        operation,
        theme,
        size,
        tabIndex,
        captchaRef
    });

    useMountEffect((isMounted) => {
        (async () => {
            try {
                const {
                    provider,
                    publicKey
                } = await getCaptchaPublicKeyDirect();

                switch (provider) {
                    case 'turnstile':
                        await getScript('https://challenges.cloudflare.com/turnstile/v0/api.js?compat=recaptcha');

                        break;
                    default:
                        await getScript(`https://www.google.com/recaptcha/api.js?render=explicit&hl=${language}`);
                }

                const { grecaptcha } = window;

                if (isMounted() && publicKey && grecaptcha) {
                    if (grecaptcha.render) {
                        renderRecaptcha(publicKey);
                    } else {
                        grecaptcha.ready(() => renderRecaptcha(publicKey));
                    }
                }
            } catch (error) {
                onError({
                    ...ERRORS.SCRIPT_LOADING_ERROR,
                    errorMessage: error?.message
                });
            }
        })();
    }, []);

    return <div ref={captchaRef} className={`${style.container} cms-recaptcha`} />;
};

export const ReCaptcha = ({ ...props }) => {
    const lang = useUserSelector(prop('lang'));

    return <ReCaptchaBare {...props} lang={lang} />;
};
